import { render, staticRenderFns } from "./LeaveTypeForm.vue?vue&type=template&id=27303c9e"
import script from "./LeaveTypeForm.vue?vue&type=script&lang=js"
export * from "./LeaveTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports